var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.903 6.1419C14.9961 6.05028 15.1218 5.99927 15.2524 6.00001C15.383 6.00075 15.5081 6.05317 15.6002 6.14583L17.8534 8.39915C17.8995 8.44464 17.9362 8.49877 17.9613 8.55845C17.9865 8.61814 17.9996 8.6822 18 8.74697C18.0004 8.81174 17.9879 8.87595 17.9635 8.93591C17.939 8.99588 17.9029 9.05042 17.8573 9.09642L10.8181 16.1361L7.86382 13.1816L14.903 6.1419ZM6.87905 14.1664L9.83337 17.1209L6.37681 17.9846C6.11092 18.0516 5.94745 17.894 6.0154 17.6232L6.87905 14.1664Z",
    fill: "#BABBBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.19334ccfa006ff35a5265b5d149053bc.svg";
export { ForwardRef as ReactComponent };